export default __webpack_public_path__ + "static/media/environment01.004ad93a.png";